import { Link, useNavigate } from "react-router-dom";
import "../App.css";
import { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import fire from "./Firebase";
import Adminheader from "../Adminheader";


function Uploadpic() {
  document.title='HR School - Upload Certificate'
  var [inputsda, setinputsda] = useState();
  var [storedatafromfirebase, setstoredatafromfirebase] = useState({});
  const navigate=useNavigate()
  function uploadimg(e) {
    var file = e.target.files[0];
    var reader = new FileReader(file);
    reader.readAsDataURL(file);
    reader.onload = function () {
      setinputsda({
        ...inputsda,
        img: reader.result,
      });

      // setgalimg({ ...galimg,})
    };
  }
  function uploadFile() {
    fire.child("data").push(inputsda, (er) => {
      if (inputsda == null) {
        toast.error("Image Is Require");
      } else toast.success("Success");
      window.location.reload(false);
    });
  }
  function logout() {
    toast.success("ID is Logout")
    //  var login=JSON.parse(localStorage.getItem('login'))
     localStorage.setItem('login',JSON.stringify({}))
     window.location.reload()

  }
  useEffect(() => {
    fire.child("data").on("value", (snapt) => {
      setstoredatafromfirebase(snapt.val());
    });
  }, []);
  function del(item){
    fire.child(`data/${item}`).remove((delt)=>{
      if(delt)toast.warning("Sorry Try Again")
      else{
        toast.success("Delete Success")
      }
    })
  }
  return (
    <div>
      <Adminheader/>
      <div className="container-fluid mimin-wrapper">
        {/* start:Left Menu */}
        <div id="left-menu">
          <div className="sub-left-menu scroll">
            <div className="wheather">
              {" "}
              <br />
              <br />
              <div
                className="stormy rainy animated pulse infinite"
                title="Hero"
              >
                <div className="shadow">Mr.H</div>
              </div>
              <div className="sub-wheather">
                <div className="thunder"></div>
                <div className="rain">
                  <div className="droplet droplet1" />
                  <div className="droplet droplet2" />
                  <div className="droplet droplet3" />
                  <div className="droplet droplet4" />
                  <div className="droplet droplet5" />
                  <div className="droplet droplet6" />
                </div>
              </div>
            </div>
            <ul className="nav nav-list">
              <li className="active ripple">
                <Link className="tree-toggle nav-header" to="/profile">
                  DashBoard
                  <span className="fa-angle-right fa right-arrow text-right" />
                </Link>
              </li>
              <li className="active ripple">
                <Link className="tree-toggle nav-header" to="/uploadpic">
                  Upload Image
                  <span className="fa-angle-right fa right-arrow text-right" />
                </Link>
              </li>
              <li className="active ripple">
                <Link className="tree-toggle nav-header" to="/uploadfile">
                  Upload Certificate
                  <span className="fa-angle-right fa right-arrow text-right" />
                </Link>
              </li>
              <li className="active ripple">
                <Link to="/viewcontact" className="tree-toggle nav-header">
                  View Contact
                  <span className="fa-angle-right fa right-arrow text-right" />
                </Link>
              </li>
              <li className="active ripple">
                <Link className="tree-toggle nav-header" to="" onClick={logout}>
                  Logout
                  <span className="fa-angle-right fa right-arrow text-right" />
                </Link>
              </li>
            </ul>
          </div>
        </div>
        {/* end: Left Menu */}
        {/* start: content */}

        {/* end: content */}
        {/* start: right menu */}
      </div>{" "}
      <br />
      <div id="content">
        <div className="col-md-12" style={{ padding: 20 }}>
          <br />
          <br />
          <center>
            {" "}
            <div
              className="App"
              style={{
                height: "auto",
                width: "100%",
                backgroundColor: "lightsteelblue",
              }}
            > <br /><br /><br />
              <input type="file" onChange={uploadimg} name="img" /> <br />
              <br />
              <button
                onClick={uploadFile}
                style={{
                  height: "60px",
                  width: "130px",
                  backgroundColor: "blueviolet",
                  color: "black",
                  textTransform: "uppercase",
                  borderRadius: "50%",
                }}
              >
                {" "}
                Upload Image
              </button> <br /><br />
            </div>
          </center> <br /><br /><div style={{width:"100%", height:"100%", backgroundColor:"lemonchiffon"}}>
          {Object.keys(storedatafromfirebase).map((snapt, index) => {
        return (
          <>
            <div id="newbox">
              <img src={storedatafromfirebase[snapt].img} alt="" style={{height:"370px", width:"100%",borderRadius:"10%"}} id="imgs"/> <br /> <br /><br />
             <center> <button onClick={() => del(snapt)} style={{backgroundColor:"gold", width:"120px",height:"60px", borderRadius:"20px"}}>Delete</button></center>
            </div>
          </> 
        );
      })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Uploadpic;
